import BaseHttpHandler from "./baseHttpHandler";
export default class ApiHttpHandler extends BaseHttpHandler {
    constructor() {
        super(process.env.REACT_APP_API_URL); //http://3.77.214.187/
    }
    fetchData(url, method, body) {
        return this.doRequest(url, method, body).then((data) => {
            return data.data;
        });
    }
}
